import React, { ReactNode } from 'react';
import { TouchableHighlight, View, ViewStyle } from 'react-native';

import styles from './touchable-card.style';
import { useColors } from '../../hooks';
import KeyboardKeyIndicator from '../keyboard-key-indicator/keyboard-key-indicator';

interface TouchableCardProps {
  onPress?: () => void;
  containerStyle?: ViewStyle;
  children: ReactNode;
  keyCode?: string;
  disabled?: boolean;
  selected?: boolean;
  selectedColor?: string;
}

export default function TouchableCard({
  onPress,
  keyCode,
  children,
  containerStyle,
  disabled = false,
  selected = false,
  selectedColor,
}: TouchableCardProps) {
  const colors = useColors();
  return (
    <TouchableHighlight
      underlayColor={colors.background}
      style={[styles.rounded, containerStyle]}
      onPress={onPress}
      disabled={disabled}
    >
      <View
        style={[
          styles.card,
          styles.rounded,
          {
            borderColor: selected
              ? selectedColor || colors.primary
              : colors.borderColor,
            backgroundColor: colors.background,
          },
        ]}
      >
        <>
          {keyCode && onPress && (
            <View style={styles.keyboardKeyIndicatorContainer}>
              <KeyboardKeyIndicator
                keyCode={keyCode}
                onKeyPress={onPress}
                disabled={disabled}
              />
            </View>
          )}
          {children}
        </>
      </View>
    </TouchableHighlight>
  );
}
